import { render, staticRenderFns } from "./RegisterPageTemplate.vue?vue&type=template&id=27616ad6&scoped=true&"
import script from "./RegisterPageTemplate.vue?vue&type=script&lang=js&"
export * from "./RegisterPageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPageTemplate.vue?vue&type=style&index=0&id=27616ad6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27616ad6",
  null
  
)

export default component.exports